import React from 'react'
import { Brain } from 'lucide-react'
import { Model } from '../../../types/models/model'
import { Project } from '../../../types/models/project'

/* Using Bootstrap utilities + gradients */

interface HeaderProps {
  selectedParent: any | null
  selectedModelId: string | null
  project?: Project
  flatNodes: any[]
}

const Header: React.FC<HeaderProps> = ({ selectedParent, selectedModelId, project, flatNodes }) => {
  return (
    <div className="bg-dark border-bottom border-secondary shadow-sm d-flex justify-content-between align-items-start gap-4 p-4">
      <div className="flex-grow-1">
        <h2 className="h4 fw-bold text-white mb-2">
          {selectedParent
            ? `Exploring ${selectedParent?.model?.name || 'Model'}`
            : 'Browse & Select Models'}
        </h2>
        <p className="text-secondary fs-6 mb-0">
          {selectedParent
            ? 'Navigate through the model hierarchy and relationships'
            : `Explore and choose from ${flatNodes.length} available models in your project`}
        </p>
      </div>

      {!selectedParent && selectedModelId && project && (
        <div className="flex-shrink-0 align-self-center">
          <div
            className="rounded-3 border border-primary px-3 py-2 d-flex align-items-center gap-2"
            style={{
              background:
                'linear-gradient(135deg, rgba(102,126,234,0.085), rgba(118,74,162,0.085))',
              minWidth: 280,
              maxWidth: 350,
            }}
          >
            <div
              className="rounded bg-gradient-primary d-flex align-items-center justify-content-center"
              style={{ width: 32, height: 32, borderRadius: 8 }}
            >
              <Brain size={16} className="text-white" />
            </div>
            <div className="flex-grow-1 text-truncate">
              <div className="fw-bold text-white text-truncate" style={{ fontSize: '.95rem' }}>
                {(
                  flatNodes.find((node) => node.model.id === selectedModelId)?.model as
                    | Model
                    | undefined
                )?.name || 'Model'}
              </div>
              <div className="d-flex align-items-center gap-2" style={{ fontSize: '.75rem' }}>
                <span className="badge bg-gradient-secondary text-white text-uppercase">
                  {(() => {
                    const m = flatNodes.find((node) => node.model.id === selectedModelId)
                      ?.model as Model
                    if (!m) return 'unknown'
                    if (m.state === 'TRAINING') return 'training'
                    if (m.state === 'TRAINED') return 'trained'
                    if (m.state === 'ERR') return 'error'
                    return 'unknown'
                  })()}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Header
